module.exports = "/_next/static/images/b2ea2b3a710a358604ef518d9b2b740d-slide-3-small.png.webp";